export function ArrowForwardIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M11.293 3.293a1 1 0 011.414 0L20.05 11h.008l-7.35-7.708 8 8c.193.193.29.445.293.698V12l-.001.048a.997.997 0 01-.292.66l-8 8a1 1 0 01-1.414-1.415L17.586 13H4a1 1 0 110-2h13.586l-6.293-6.293a1 1 0 010-1.414z"
      ></path>
    </svg>
  );
}
